import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginAnimationService {
  private showGeometricAnimationSubject = new BehaviorSubject<boolean>(false);
  public showGeometricAnimation$ = this.showGeometricAnimationSubject.asObservable();

  triggerGeometricAnimation(): void {
    this.showGeometricAnimationSubject.next(true);
  }

  resetGeometricAnimation(): void {
    this.showGeometricAnimationSubject.next(false);
  }
}
